import { abGetDefaultCity } from '../ab/widgets-home';
import { c_cities, CCityId } from '../mdl/c-city';
import { cVenuesByCity } from '../mdl/c-venue';
import { FPageMapBlock } from '../mdl/f-page-block';
import { getDataValue, registerDataListener } from '../ui/component/field-tag';
import { UIMap } from '../ui/component/maps';
import { $el } from '../ui/elements';
import { $cdn } from '../y/cdn';
import { YId } from '../y/types';
import { blkRegister } from './registry';

const map_style: google.maps.MapTypeStyle[] = [{
    elementType: 'geometry',
    stylers: [{ color: '#4f4f4f' }]
}, {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }]
}, {
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }]
}, {
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#212121' }]
}, {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [{ color: '#7a7a7a' }, { 'weight': 1 }]
}, {
    featureType: 'administrative.country',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }]
}, {
    featureType: 'administrative.land_parcel',
    stylers: [{ visibility: 'off' }]
}, {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#bdbdbd' }]
}, {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }]
}, {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#404040' }]
}, {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#616161' }]
}, {
    featureType: 'poi.park',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#1b1b1b' }]
}, {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{ color: '#707070' }]
}, {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#8a8a8a' }]
}, {
    featureType: 'transit',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }]
}, {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#212121' }]
}, {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#3d3d3d' }]
}];

blkRegister<FPageMapBlock>('map', (_b, _s, _p, _id) => {
    const added_cities: { [id: YId]: boolean } = {};
    const map = new UIMap({ lat: 59.329444, lng: 18.068611 }, map_style);
    const block = $el.DIV('blk-map b b-block', map);

    const toCity = (id: CCityId | undefined) => {
        const city = c_cities.maybe(id!)!;

        map.map.then(map => {
            map.setCenter(city.location);
        });

        if(added_cities[id!]) return;
        added_cities[id!] = true;

        cVenuesByCity(city.id).then(venues => {
            for(const v of venues) {
                if(v.flags['no_map'] || !v.location) continue;
                map.addMarker(v.location, v.name, $cdn('images/assets/xx-map-marker.png'), () => {
                    return $el.SPAN('o-map-popup', v.name);
                });
            }
        });
    }

    toCity(getDataValue(block, 'city') ?? abGetDefaultCity().id);
    registerDataListener(block, 'city', toCity);

    return block;
});